import type { TSharedCardStatus } from '#interfaces/sharedCardStatus'

import type { TShareStatusFilter } from './interfaces'

const CARD_STATUS_FROM_SEARCH: Record<string, TSharedCardStatus> = {
  blocked: 'ended',
  in_production: 'requested',
  requested: 'requested',
  available: 'available',
  active: 'active',
  ended: 'ended',
}

export interface ILegacySharedCardSearch {
  cardStatus?: TSharedCardStatus
  shareStatus?: TShareStatusFilter
}

/**
 * Maps a shared-card route's query string onto the current card-status and
 * share-status values. An explicit cardStatus wins over a legacy
 * assignment/shareStatus of `available`. Unknown values are dropped.
 */
export function mapLegacySharedCardSearch(
  search: Record<string, unknown>,
  shareKey: 'assignment' | 'shareStatus',
): ILegacySharedCardSearch {
  const rawCardStatus = search.cardStatus
  const hasExplicitCardStatus = typeof rawCardStatus === 'string' && rawCardStatus.length > 0
  const cardStatus = hasExplicitCardStatus ? CARD_STATUS_FROM_SEARCH[rawCardStatus] : undefined
  const rawShare = search[shareKey]

  if (rawShare === 'available' && !hasExplicitCardStatus) return { cardStatus: 'available' }

  const shareStatus = rawShare === 'assigned' || rawShare === 'unassigned' ? rawShare : undefined

  return {
    ...(cardStatus !== undefined ? { cardStatus } : {}),
    ...(shareStatus !== undefined ? { shareStatus } : {}),
  }
}
